export default "__VITE_ASSET__GG7uBL0o__"